import { Box } from "@mui/joy";
import DarkTypography from "components/common/DarkTypography";
import { excursionPeopleFillTone } from "./excursionCardUtils";
import { colorTokens, textTokens } from "styles/globalStyles";

export type ExcursionPlanningDayFillLineProps = {
  totalPeople: number;
  totalMax: number;
  percent: number;
};

export default function ExcursionPlanningDayFillLine({
  totalPeople,
  totalMax,
  percent,
}: ExcursionPlanningDayFillLineProps) {
  const tone = excursionPeopleFillTone(totalPeople, totalMax);
  const color =
    tone === "full"
      ? colorTokens.status.danger
      : tone === "warning"
        ? colorTokens.status.warning
        : textTokens.color.muted;

  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", alignItems: "center", minWidth: 0 }}
      aria-label={`Remplissage du jour : ${totalPeople} personnes sur ${totalMax} places (${percent} %)`}
    >
      <DarkTypography
        level="body-xs"
        component="div"
        sx={{ color, fontWeight: 700, fontSize: "0.65rem", lineHeight: 1.2 }}
      >
        {percent} %
      </DarkTypography>
    </Box>
  );
}
